import React from 'react'

export const WatchSolid = () => {
  return (
    <svg
      className='watch-placeholder svg-inline--fa fa-watch'
      aria-hidden='true'
      focusable='false'
      data-prefix='fad'
      data-icon='watch'
      role='img'
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 384 512'
      data-fa-i2svg=''
    >
      <g className='fa-duotone-group'>
        <path
          className='fa-secondary'
          fill='currentColor'
          style={{ opacity: 0.4 }}
          d='M0 256C0 149.1 85.96 64 192 64C298 64 384 149.1 384 256C384 362 298 448 192 448C85.96 448 0 362 0 256zM216 176C216 162.7 205.3 152 192 152C178.7 152 168 162.7 168 176V256C168 264 172 271.5 178.7 275.1L226.7 307.1C237.7 315.3 252.6 312.3 259.1 301.3C267.3 290.3 264.3 275.4 253.3 268L216 243.2L216 176z'
        />
        <path
          className='fa-primary'
          fill='currentColor'
          d='M64 48C64 21.49 85.49 0 112 0H272C298.5 0 320 21.49 320 48V112.9C286 82.49 241.2 64 192 64C142.8 64 97.97 82.49 64 112.9V48zM192 448C241.2 448 286 429.5 320 399.1V464C320 490.5 298.5 512 272 512H112C85.49 512 64 490.5 64 464V399.1C97.97 429.5 142.8 448 192 448zM216 243.2L253.3 268C264.3 275.4 267.3 290.3 259.1 301.3C252.6 312.3 237.7 315.3 226.7 307.1L178.7 275.1C172 271.5 168 264 168 255.1V175.1C168 162.7 178.7 151.1 192 151.1C205.3 151.1 216 162.7 216 175.1L216 243.2z'
        />
      </g>
    </svg>
  )
}